import Vue from 'vue'
import App from './App.vue'
import { Search, DatetimePicker , DropdownMenu, DropdownItem, Button, Field, List, Calendar, Cell, Dialog, Icon, Picker, Popup, Notify, Tab, Tabs, RadioGroup, Radio, Uploader, Image as VanImage, ImagePreview, Col, Row, Form, Checkbox, CheckboxGroup, Switch, Tag, Stepper, NavBar } from 'vant';
import router from './router';
import util from './util/utils'
import store from './store';
import { installBackNavigation } from './util/backNavigation';
import { installVersionCheck } from './util/appVersion';
Vue.use(Button);
Vue.use(Field);
Vue.use(List);
Vue.use(Calendar);
Vue.use(Cell);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Notify);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Uploader);
Vue.use(VanImage);
Vue.use(Col);
Vue.use(Row);
Vue.use(Form);
Vue.use(ImagePreview);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Tag);
Vue.use(Stepper);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Search);
Vue.use(Switch);
Vue.use(NavBar);
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$http = util.http

installBackNavigation(router)
installVersionCheck()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
